import { HolderOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "../button";

export function DragButton(props: ButtonProps) {
  return (
    <Button
      type="text"
      icon={<HolderOutlined />}
      size="small"
      style={{ cursor: "move" }}
      {...props}
    />
  );
}
